import {useEffect,useRef,useState} from 'react';
import {supabase} from '../lib/supabaseClient';
import {watchPontoonProgress} from '../lib/pontoonRefresh';
import {buildTeamCrestMap,buildTeamPresentationIndex} from '../lib/teamAssets';
const empty={fixtures:null,picks:null,rows:null,loading:true,error:false,updatedAt:null};
export function usePontoonProgress(competition,week,entryId) {
  const [snapshot,setSnapshot]=useState(empty),[media,setMedia]=useState(()=>({crests:{},teamPresentation:buildTeamPresentationIndex([])}));
  const watcher=useRef(null);
  const scope=`${competition?.id}:${week}:${entryId||'all'}`;
  useEffect(()=>{
    if(!competition?.id||week==null){setSnapshot({...empty,scope,loading:false});return;}
    setSnapshot({...empty,scope});
    const read=async q=>{const r=await q;if(r.error)throw r.error;return r.data||[];};
    const refresh=async active=>{
      try{
        let picks=supabase.from('pontoon_picks').select('entry_id, match_day, selection_number, fixture_id, selected_team').eq('competition_id',competition.id).eq('match_day',week);
        let rows=supabase.from('pontoon_matchday').select('entry_id, match_day, predicted_total_goals, weekly_score, outcome, is_winner').eq('competition_id',competition.id).eq('match_day',week);
        if(entryId){picks=picks.eq('entry_id',entryId);rows=rows.eq('entry_id',entryId);}
        const [fixtures,pk,pm]=await Promise.all([
          read(supabase.from('fixtures').select('id, match_day, home_team, away_team, home_team_id, away_team_id, home_score, away_score, kickoff_time, status').eq('league',competition.league).eq('season',competition.season).eq('match_day',week)),read(picks),read(rows),
        ]);
        if(active())setSnapshot({scope,fixtures,picks:pk,rows:pm,loading:false,error:false,updatedAt:Date.now()});
      }catch{if(active())setSnapshot({...empty,scope,loading:false,error:true});}
    };
    const next=watchPontoonProgress({client:supabase,competitionId:competition.id,league:competition.league,refresh});watcher.current=next;
    return ()=>{next.stop();if(watcher.current===next)watcher.current=null;};
  },[competition?.id,competition?.league,competition?.season,week,entryId]);
  useEffect(()=>{
    if(!competition?.id){setMedia({crests:{},teamPresentation:buildTeamPresentationIndex([])});return;}
    let active=true;
    const update=teams=>{if(active)setMedia({crests:buildTeamCrestMap(teams),teamPresentation:buildTeamPresentationIndex(teams)});};
    supabase.from('teams').select('id, official_name, display_name, footystats_name, code, logo_url')
      .then(({data,error})=>update(error?[]:data||[]),()=>update([]));
    return()=>{active=false;};
  },[competition?.id]);
  return {...(snapshot.scope===scope?snapshot:empty),...media,refresh:()=>watcher.current?.refresh()};
}
